import { Box, useTheme } from '@mui/material'
import { Outlet } from 'react-router-dom'
import { MiniSidebar } from '@/shared/layouts/Sidebar'

const DRAWER_WIDTH = 65

export const PrivateLayout = () => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '3px',
          background: `linear-gradient(90deg, 
            ${theme.palette.primary.main}, 
            ${theme.palette.secondary.main},
            ${theme.palette.info.main}
          )`,
          zIndex: 9999, // Ensure it's above all content
        },
      }}
    >
      <MiniSidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: `calc(100% - ${DRAWER_WIDTH}px)`,
          height: '100%',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  )
}
